import { render, staticRenderFns } from "./exam-manage.vue?vue&type=template&id=05fc0ff9&scoped=true"
import script from "./exam-manage.vue?vue&type=script&lang=js"
export * from "./exam-manage.vue?vue&type=script&lang=js"
import style0 from "./exam-manage.vue?vue&type=style&index=0&id=05fc0ff9&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fc0ff9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05fc0ff9')) {
      api.createRecord('05fc0ff9', component.options)
    } else {
      api.reload('05fc0ff9', component.options)
    }
    module.hot.accept("./exam-manage.vue?vue&type=template&id=05fc0ff9&scoped=true", function () {
      api.rerender('05fc0ff9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/research/exam-manage.vue"
export default component.exports